// src/auth/msalConfigHavoxCases.ts
export const msalConfigHavoxCases = {
  auth: {
    clientId: "833dbee3-8023-419b-889b-48f25c4a8930",
    authority:
      "https://login.microsoftonline.com/99d27c0c-94a0-437d-b394-72afe6a5ba08",
    redirectUri: window.location.origin,
  },
  cache: { cacheLocation: "localStorage" },
};

export const loginRequestHavoxCases = {
  scopes: ["openid", "profile", "offline_access", "Files.ReadWrite"],
};
